import { shopping } from './collections/shopping';
import { santa } from './collections/santa';
import { house } from './collections/house';
import { fruits } from './collections/fruits';
import { pets } from './collections/pets';
import { vegetables } from './collections/vegetables';
import { kitchen } from './collections/kitchen';
import { surprise } from './collections/surprise';
import { internet } from './collections/internet';
import { valentines } from './collections/valentines';
import { home } from './collections/home';
import { dental } from './collections/dental';
import { essentials } from './collections/essentials';
import { creativity } from './collections/creativity';
import { photography } from './collections/photography';
import { forest } from './collections/forest';
import { tropicalFruits } from './collections/tropical-fruits';
import { holi } from './collections/holi';
import { spring } from './collections/spring';
import { shower } from './collections/shower';
import { olympics } from './collections/olympics';
import { essentials2 } from './collections/essentials-2';

// Export all collections
export const collections = {
  shopping,
  santa,
  house,
  fruits,
  pets,
  vegetables,
  kitchen,
  surprise,
  internet,
  valentines,
  home,
  dental,
  essentials,
  creativity,
  photography,
  forest,
  tropicalFruits,
  holi,
  spring,
  shower,
  olympics,
  essentials2
};

// Export flattened array of all stickers
export const stickers = Object.values(collections).flat();